<template>
  <div class="select-wrap">
      <div class="select-content" @click="showActionsheet=true">
        <!-- <slot name="leftIcon"></slot> -->
        <span>{{text}}</span>
        <span v-if="rightIcon" class="iconfont fs1">&#xe748;</span>
      </div>
      <van-actionsheet v-model="showActionsheet" cancel-text="取消" :actions="actions" @select="onSelect" class="select-actionsheet"/>
  </div>
</template>

<script>
import Vue from "vue";
import { Actionsheet } from 'vant';
Vue.use(Actionsheet);
export default {
  props: {
    text: String,
    actions: Array,
    rightIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showActionsheet: false
    }
  },
  methods: {
    onSelect(item) {
      this.showActionsheet = false;
      this.$emit('select', item)
    }
  }
}
</script>

<style lang="less">
.select-wrap {
  .select-actionsheet {
    max-height: 5rem;
    ol, ul {
      -webkit-padding-start: 0;
    }
    .van-actionsheet__cancel, .van-actionsheet__item {
      font-size: .14rem;
      padding: 0 .1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Select.vue